import { render, staticRenderFns } from "./InfoautoCustomerStats.vue?vue&type=template&id=25b56d88&scoped=true"
import script from "./InfoautoCustomerStats.vue?vue&type=script&lang=js"
export * from "./InfoautoCustomerStats.vue?vue&type=script&lang=js"
import style0 from "./InfoautoCustomerStats.vue?vue&type=style&index=0&id=25b56d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b56d88",
  null
  
)

export default component.exports